<template>
	<div class="adQuizQuestion">
		<div v-if="page == 'question'" class="d-flex flex-column h-100">
			<h5 :class="'text-primary mt-4 mb-3 ' + (adQuiz.videoUrl == undefined ? 'text-center' : 'text-right')">
				{{ $t('home.question_award_text') }} <b>{{ adQuiz.userProfit }}</b> <img src="/images/token.png" style="width: 1em" />
			</h5>
			<div :class="'question mb-4' + (adQuiz.videoUrl == undefined ? ' no-video' : '')">
				<img
					v-if="adQuiz.videoUrl != undefined"
					:src="'/images/theme/' + (user.mtsCustomer ? 'mts' : 'default') + '/bear/bear-question.png'"
					class="animate__animated animate__fadeInLeft animate__faster"
				/>
				<progress-bar
					v-else
					type="circle"
					ref="circle"
					:options="progressOptions"
					class="timer animate__animated animate__zoomIn animate__faster"
				></progress-bar>
				<p class="animate__animated animate__fadeInLeft animate__fast">{{ question.text }}</p>
			</div>
			<ul class="answers animate__animated animate__fadeInUp animate__faster animate__delay-1s">
				<li
					@click="
						setAnswer(a)
						btnSfx()
					"
					v-for="a in question.answers"
					:key="a.id"
					:class="selectedAnswerId == a.id ? selectedAnswerClass : ''"
				>
					{{ a.text }} <i class="fas fa-check-circle"></i><i class="fas fa-times-circle"></i>
				</li>
			</ul>
		</div>
		<div v-else-if="page == 'results'" class="d-flex flex-column justify-content-center h-100">
			<div class="bear-results mt-4 p-3 d-flex">
				<img
					v-if="selectedAnswerClass == 'correct'"
					:src="'/images/theme/' + (user.mtsCustomer ? 'mts' : 'default') + '/bear/bear-question-ok.png'"
					class="animate__animated animate__fadeInLeft"
				/>
				<img
					v-else
					:src="'/images/theme/' + (user.mtsCustomer ? 'mts' : 'default') + '/bear/bear-question-sad.png'"
					class="animate__animated animate__fadeInLeft animate__faster"
				/>
				<p class="animate__animated animate__bounceIn animate__faster animate__delay-1s">
					{{ $t('home.question_result_bear__' + selectedAnswerClass) }}
				</p>
			</div>
			<div class="actionButtons text-center animate__animated animate__fadeIn">
				<h5 class="text-primary mb-4">{{ $t('home.question_result__' + selectedAnswerClass) }}</h5>
				<div v-if="selectedAnswerClass == 'correct'" class="p-4">
					<div class="text-center mb-2">{{ $t('home.question_result_award') }}</div>
					<h1 class="text-center text-yellow">
						<b>{{ answer.profit.abbr(true) }} <img src="/images/token-no-border.png" /></b>
					</h1>
				</div>
				<div v-if="!demo && selectedAnswerClass == 'wrong' && answer.remainingAttempts > 0" class="pl-4 pr-4 pt-4 animate__animated animate__fadeIn">
					<b-button
						@click="
							retryQuiz()
							btnSfx()
						"
						variant="success"
						size="lg"
						class="mb-3 pt-3 pb-3"
						>{{ $t('home.question_result_retry_btn') }}</b-button
					>
					<div class="text-center mb-2">{{ $t('home.question_result_retry_btn') }}</div>
					<h3 class="text-center text-yellow">
						<b>{{ answer.potentialProfit.abbr(true) }} <img src="/images/token-no-border.png" /></b>
					</h3>
				</div>
				<div class="p-4 animate__animated animate__fadeIn">
					<b-button
						@click="
							next()
							btnSfx()
						"
						variant="primary"
						size="lg"
						class="mb-3 pt-3 pb-3"
						>{{ $t('base.btn_continue') }}</b-button
					>
					<button
						v-if="!demo"
						@click="
							$emit('eventClose')
							btnSfx()
						"
						type="button"
						class="btn btn-link btn-block btn-lg"
					>
						{{ $t('base.btn_close') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import app from '../app'
import api from '../api'

const AdQuizQuestion = Vue.component('adquiz-question', {
	props: {
		demo: { type: Boolean, default: false },
		retry: { type: Boolean, default: false },
		adQuiz: {
			type: Object,
			required: true,
			default() {
				return {
					maxAttemptCount: 1,
					questionCount: 1,
					userProfit: 0,
					videoUrl: undefined,
					question: {
						text: '...',
						answers: [],
					},
				}
			},
		},
	},

	questionTimer: null,

	data() {
		return {
			question: {
				text: '...',
				answers: [],
			},
			answer: null,
			selectedAnswerId: 0,
			selectedAnswerClass: '',
			page: 'question',
			locked: false,
			duration: 1300,
			progressOptions: {
				color: '#ff8500',
				trailColor: '#abccee',
				strokeWidth: 14,
				trailWidth: 14,
				from: { color: '#ff4e36' },
				to: { color: '#ff8500' },
				step: function (state, circle, attachment) {
					circle.path.setAttribute('stroke', state.color)
				},
			},
		}
	},

	computed: {
		user() {
			return this.$store.state.auth.user
		},
	},

	methods: {
		btnSfx() {
			this.$store.dispatch('sound/sfx', 'Button')
		},

		async setAnswer(answer) {
			if (this.locked) return
			this.locked = true

			const $this = this
			let loader = document.getElementById('loader')
			loader.classList.add('show')

			this.selectedAnswerId = answer.id
			this.selectedAnswerClass = 'selected'

			try {
				let response = this.demo ? await api.setAdQuizDemoAnswer(answer.id) : await api.setAdQuizAnswer(this.adQuiz.id, this.question.id, answer.id)
				this.answer = response.data

				if (this.questionTimer != null) {
					clearInterval(this.questionTimer)
					this.questionTimer = null
				}

				if (response.data.status == 'CORRECT_ANSWER') {
					this.selectedAnswerClass = 'correct'
					this.$store.dispatch('sound/sfx', 'Achievements')
				} else {
					this.selectedAnswerClass = 'wrong'
					this.$store.dispatch('sound/sfx', 'Fail')
				}

				if (this.demo) {
					if (response.data.status != 'CORRECT_ANSWER') {
						this.locked = false
					} else {
						this.$emit('eventDemoCollected', response.data.profit)
						setTimeout(function () {
							$this.page = 'results'
						}, 750)
					}
				} else {
					this.$emit('eventUpdateUser')
					setTimeout(function () {
						$this.page = 'results'
					}, 750)
				}
			} catch (error) {
				this.locked = false
				api.baseErrorHendler(error)
			}

			loader.classList.remove('show')
		},

		setTimer() {
			if (this.questionTimer != null) {
				clearInterval(this.questionTimer)
				this.questionTimer = null
			}

			if (this.adQuiz.videoUrl != undefined || this.question.timeout == undefined) return

			let durationSec = moment.duration(this.question.timeout).seconds()
			let current = durationSec

			this.$refs.circle.setText(current)
			this.questionTimer = setInterval(() => {
				current -= 1 // count down (-1000 ms)
				this.$refs.circle.animate(current / durationSec)
				if (current >= 0) {
					this.$refs.circle.setText(current)
				} else {
					this.selectedAnswerClass = 'timeout'
					this.page = 'results'
					clearInterval(this.questionTimer)
					this.questionTimer = null
				}
			}, 1000)

			this.$refs.circle.set(1)
		},

		formatTime(time) {
			let t = moment.utc(time)
			if (t.hours() > 0) return t.format('h:mm[h]')
			else if (t.minutes() > 0) return t.format('m:ss[m]')

			return t.seconds()
		},

		retryQuiz() {
			if (!this.demo && this.selectedAnswerClass == 'wrong' && this.answer != null && this.answer.remainingAttempts > 0)
				this.$emit('eventRetry', { question: this.question, answer: this.answer })
			else this.$emit('eventClose')
		},

		next() {
			if (!this.demo && this.answer != null && (this.answer.adSurveyQuestionAvailable || this.answer.userSegmentationQuestionAvailable)) {
				this.$emit('eventNextProfiling', {
					adSurveyUserProfitCurrency: this.answer.adSurveyUserProfitCurrency,
					adSurveyQuestionAvailable: this.answer.adSurveyQuestionAvailable,
					userSegmentationQuestionAvailable: this.answer.userSegmentationQuestionAvailable,
				})

				return
			}
			this.$emit('eventNextVideo')
		},

		async init() {
			// console.log("INIT QUSTION", this.adQuiz);
			document.getElementById('loader').classList.remove('show')

			this.selectedAnswerId = 0
			this.selectedAnswerClass = ''
			this.page = 'question'
			this.locked = false

			if (this.adQuiz.question != undefined) {
				this.question = this.adQuiz.question
				this.setTimer()
				return
			}

			let loader = document.getElementById('loader')
			loader.classList.add('show')

			try {
				let response = this.demo ? await api.adQuizDemoQuestion() : await api.adQuizQuestion(this.adQuiz.id)
				this.question = response.data
				this.setTimer()
			} catch (error) {
				api.baseErrorHendler(error)
			}

			loader.classList.remove('show')
		},
	},

	mounted() {
		this.init()
	},

	beforeDestroy() {
		document.getElementById('loader').classList.remove('show')
		if (this.questionTimer != null) {
			clearInterval(this.questionTimer)
			this.questionTimer = null
		}
	},

	watch: {
		adQuiz: {
			handler(val, old) {
				if (val.id != old.id || (old.videoUrl == undefined && val.question != old.question)) this.init()
			},
		},
	},
})

export default AdQuizQuestion
</script>
